<template>
  <v-dialog
    :model-value="dialog"
    max-width="400"
    @click:outside="$emit('close')"
  >
    <v-card>
      <v-card-title class="pt-4">Import {{textToLowerCase}}</v-card-title>
      <v-card-text class="pl-4 pt-0">
        The current {{text}} will be replaced by an imported {{textToLowerCase}}. <br><br>

        Are you sure you want to continue?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :loading="loading"
          color="primary"
          text
          @click="$emit('import')"
        >
          Continue
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ImportDialog",
  props: {
    dialog: {type: Boolean, default: false},
    loading: {type: Boolean, default: false},
    text: {default: ''},
  },
  computed: {
    textToLowerCase() {
      return this.text.toLowerCase();
    }
  }
}
</script>
